export default "https://cdn-static.gokick.com/assets/4e3548e0bbc963e39203d4ae4090204efad0894d/images/logo.fe82f4ad349e614dc769d17dbf45d7bb.svg";